import { ExtractionResult } from '../types/invoice';
import { fileToBase64 } from '../utils/files';
import { API_BASE_URL } from '@/constants/config';
import { logger } from '@/lib/logger';

/**
 * Extract invoice data using the backend API endpoint
 * This keeps the OpenAI API key secure on the server side
 */
export const extractInvoiceData = async (
  xmlFile: File | null,
  pdfFile: File | null
): Promise<ExtractionResult> => {
  if (!xmlFile && !pdfFile) {
    throw new Error('No se proporcionaron archivos para extracción.');
  }

  try {
    // Prepare content for backend
    let xmlContent = '';
    let pdfBase64 = '';
    let pdfFilename = '';

    // Process XML (read as text)
    if (xmlFile) {
      try {
        xmlContent = await xmlFile.text();
      } catch (err) {
        logger.error('Error procesando XML', { error: err });
        throw new Error('Error al procesar archivo XML');
      }
    }

    // Process PDF (convert to base64)
    if (pdfFile) {
      try {
        pdfBase64 = await fileToBase64(pdfFile);
        pdfFilename = pdfFile.name;
      } catch (err) {
        logger.error('Error procesando PDF', { error: err });
      }
    }

    // Call backend extraction API
    const response = await fetch(`${API_BASE_URL}/api/extract`, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        xmlContent: xmlContent || undefined,
        pdfBase64: pdfBase64 || undefined,
        pdfFilename: pdfFilename || undefined,
      }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      logger.error('Error de API', { error: data.error, message: data.message, details: data.details });
      throw new Error(data.message || 'Error al extraer datos de la factura');
    }

    const result = data.data as ExtractionResult;

    return result;
  } catch (error: unknown) {
    const err = error as Error;
    logger.error('Error en extracción', { message: err.message });
    throw error;
  }
};
